import HeaderBimLinksButtons from 'components/Bimlink/ViewerBimLinkPage/HeaderBimLinksButtons'
import { TableAllBimLinks_v2 } from 'components/Bimlink/ViewerBimLinkPage/TableAllBimLinks_v2'

const BimLinkPage = () => {

  return (
    <div className="bim-link-panel-container">
      <HeaderBimLinksButtons />
      <TableAllBimLinks_v2 />
    </div>
  )
}

export default BimLinkPage
